module.exports = __webpack_public_path__ + "img/meal-plan-dash.dc95b799.gif";